// Which events belong to which trip (D1). Learning, the family, the controls and the prize pool
// carry over from trip to trip; places, check-ins, plays earned, prizes won and suggestions are
// the trip's own, so a new trip starts with an empty Crate and past trips keep theirs. Events
// from before trips existed have no trip: they belong to the first one.

export const TRIP_SCOPED = new Set([
  'place.wanted',
  'place.unwanted',
  'checkin',
  'place.found',
  'reward.earned',
  'reward.awarded',
  'plays.granted',
  'prize.won',
  // WI-13: what twists paid (collectibles, act keys) and holiday tasks are the trip's own.
  'reward.paid',
  'task.set',
  'task.removed',
  'task.asked',
  'task.done',
  'prize.redeemed',
  'suggestion.resolved',
])

export function inTrip(e: { type: string; tripId?: string }, activeTrip: string, firstTrip: string): boolean {
  if (!TRIP_SCOPED.has(e.type)) return true
  return (e.tripId ?? firstTrip) === activeTrip
}
